import React, { Dispatch, SetStateAction, useContext } from "react";

type IAppContext = {
  pageLoading: boolean;
  setPageLoading: Dispatch<SetStateAction<boolean>>
  userData: any
}

const initValue: IAppContext = {
  pageLoading: false,
  setPageLoading: () => {},
  userData: {}
}

const AppContext = React.createContext(initValue);
const useLoading = () => useContext(AppContext);
const useAppContext = () => useContext(AppContext);

export { useLoading, AppContext, useAppContext }